/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Pr_2Inputs */

const en_fc_vs_who_pr_2 = /** @type {(inputs: Fc_Vs_Who_Pr_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rely on AI features, third-party plugins or After Effects round-trips`)
};

/**
* | output |
* | --- |
* | "rely on AI features, third-party plugins or After Effects round-trips" |
*
* @param {Fc_Vs_Who_Pr_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_pr_2 = /** @type {((inputs?: Fc_Vs_Who_Pr_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Pr_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_pr_2(inputs)
});
export { fc_vs_who_pr_2 as "fc.vs.who.pr.2" }